import axios from 'axios';

export default class psCalendar {
    constructor(el) {
        if (!el) {
            return;
        }

        this.el = el;

        this.list = this.el.querySelector('.ps-calendar-list');
        this.listLoader = this.list && this.list.querySelector('.ajax-loading');
        this.listDiv = document.getElementById("calendarDiv");

        this.filters = this.el.querySelector('.ps-filter-list');
        this.filterLoader = this.filters && this.filters.querySelector('.ajax-loading');

        this.page = parseInt(this.listDiv.getAttribute('data-page')) || 1;
        this.itemsPerPage = parseInt(this.listDiv.getAttribute('data-items-per-page')) || 3;
        this.isPsStartPage = this.listDiv.getAttribute('data-ispsstartpage');

        this.prev = this.list.querySelector(".pagination-button.prev");
        this.next = this.list.querySelector(".pagination-button.next");

        this.calendarBlock = parseInt(this.listDiv.getAttribute('data-items-calendar-event-id'));

        this._initPagination();
        this._initFiltering();
    }

    _initPagination() {
        const eventHandler = event => {
            event.preventDefault();

            if (event.target.hasAttribute('disabled')) {
                return;
            }

            const gotoPage = event.target === this.prev ? this.page - 1 : this.page + 1;
            const pageMax = Math.ceil(this._getTotalItemCount() / this.itemsPerPage);

            if (1 <= gotoPage && gotoPage <= pageMax) {
                this._update(false, gotoPage);
            }
        };

        this.prev.addEventListener('click', eventHandler);
        this.next.addEventListener('click', eventHandler);
    }

    _initFiltering() {
        this.filters && this.filters.addEventListener('change', event => {
            if (event.target.tagName === 'INPUT' && event.target.type === 'checkbox') {
                this._update(true);
            }
        });
    }

    async _update(updateProfile, page) {
        const loader = page ? this.listLoader : this.filterLoader;
        page = page || 1;

        this._toggleLoader(loader, true);

        let data, url;

        if (this.calendarBlock > 0) {
            url = "/api/calendar";
            data = new FormData();
            data.append('calendarEventListingId', this.calendarBlock);
        } else if (this.filters) {
            const form = this.filters.querySelector('form');
            url = form.action;
            data = new FormData(form);
        }

        data.append('page', page);
        data.append('pagelimit', this.itemsPerPage);
        data.append('updateProfile', updateProfile === true);
        data.append('isPsStartPage', this.isPsStartPage);

        try {
            const response = await axios.post(url, data);
            this.listDiv.innerHTML = response.data;
            this.listDiv.setAttribute('data-page', page);
            this.page = page;
            this.totalItemCount = this._getTotalItemCount();
            this._updatePagination();
        } catch (error) {
            this.listDiv.innerHTML = error.status;
        }

        this._toggleLoader(loader, false);
    }

    _getTotalItemCount() {
        const count = parseInt(document.getElementById("ps-calendar-wrapper")?.getAttribute('data-total-item-count'));
        return count || 0;
        //const wrapper = document.getElementById("ps-calendar-wrapper");
        //return wrapper && parseInt(document.getElementById("ps-calendar-wrapper")?.getAttribute('data-total-item-count'));
    }

    _toggleLoader(element, visible) {
        element.toggleAttribute('hidden', !visible);
    }

    _updatePagination() {
        const disablePrev = this.page === 1;
        this.prev.toggleAttribute("disabled", disablePrev);

        const pageMax = Math.ceil(this._getTotalItemCount() / this.itemsPerPage);
        const disableNext = this.page >= pageMax;
        this.next.toggleAttribute("disabled", disableNext);

        const counter = this.el.querySelector('.ps-calendar-list__pagination-and-filter .pagination-counter');
        if (counter) {
            counter.innerHTML = this.page + ' / ' + pageMax;
        }
    }
}
